import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'

import { UploadButton, UploadList } from "../../components";
import PanelFineMom from '../PanelFineMom';

import { Input,InputDecimal, DatePicker, TextArea } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import { red } from "@material-ui/core/colors";

class PanelFine extends Component {

    constructor(props) {
        super(props)

        this.state = {
            transaction_no:'',
            ir_amount:0,
            sum_penalty_cal:0,
            retention_cal:0,
            advance_payment_cal:0,
            mr_amount:0
        }
        
        this.handleChange = this.handleChange.bind(this)
       // this.handleChangeByName = this.handleChangeByName.bind(this)
        this.handleInTimeChange = this.handleInTimeChange.bind(this)
        this.handlePenaltyChange = this.handlePenaltyChange.bind(this)
        
        this.handleOtherPenaltyChange = this.handleOtherPenaltyChange.bind(this)
        this.handleRetentionChange = this.handleRetentionChange.bind(this)
        this.handleAdvancePaymentChange = this.handleAdvancePaymentChange.bind(this)

        this.chkNumber = this.chkNumber.bind(this)
        this.recalIRAmount = this.recalIRAmount.bind(this)
        this.recalMRAmount = this.recalMRAmount.bind(this)
        this.setFormateMomey = this.setFormateMomey.bind(this)

        window.handleMRAmount = this.handleMRAmount.bind(this)
        
        
        
        this.penalty_result_ref = React.createRef();
        this.penalty_no_result_ref = React.createRef();

        // this.delay_day_no_ref = React.createRef();
        this.delay_remark_ref = React.createRef();

        // this.penalty_amount_ref = React.createRef();
        // this.penalty_doc_no_ref = React.createRef();
        // this.penalty_doc_date_ref = React.createRef();

        this.approval_of_penalty_exception_doc_no_ref = React.createRef();
        //this.approval_of_penalty_exception_doc_date_ref = React.createRef();

        //this.other_penalty_amount_ref = React.createRef();
        this.other_penalty_remark_ref = React.createRef();
        //this.retention_amount_ref = React.createRef();
        this.retention_remark_ref = React.createRef();
        //this.advance_payment_amount_ref = React.createRef();
        this.advance_payment_remark_ref = React.createRef();

    }

    handleMRAmount(){
        this.recalIRAmount()
    }
    chkNumber(value){
        return value?parseFloat(value.toString().replace(/[^0-9.-]+/g,"")):0
    }
    setFormateMomey(value){
        const numeral = require('numeral');
        return numeral(value).format("0,0.00")
    }
    recalIRAmount(){
        let sum = 0;
        let { t_MR_DETAIL } = this.props;
        
        this.props.t_IR_ITEM.map((m, index)=>{
            if(m.amount && (m.checked===1 || m.checked===true || m.checked==='1')){
                sum += parseFloat(m.amount)
            }
        })
        // if(this.state.ir_amount != sum || this.props.t_MR_DETAIL.mr_ref_no!=null)
        this.setState({
            ir_amount : this.setFormateMomey(sum),
            sum_penalty_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.penalty_amount_net)
                    +this.chkNumber(t_MR_DETAIL.other_penalty_amount)
                ),
            retention_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.retention_amount)
                ),
            advance_payment_cal:
                this.setFormateMomey(
                    this.chkNumber(t_MR_DETAIL.advance_payment_amount)
                ),
            mr_amount : 
                this.setFormateMomey(
                    (this.chkNumber(t_MR_DETAIL.up_dept_amount ) + sum) - 
                    ( 
                         this.chkNumber(t_MR_DETAIL.penalty_amount_net)+
                        this.chkNumber(t_MR_DETAIL.other_penalty_amount)+ 
                        this.chkNumber(t_MR_DETAIL.down_dept_amount)+
                        this.chkNumber(t_MR_DETAIL.retention_amount)+
                        this.chkNumber(t_MR_DETAIL.advance_payment_amount)
                    )
                ),
        })
    }

    recalMRAmount(name,changeValue){
        let dataState = this.state
        let {t_MR_DETAIL} = this.props
        switch(name){
            case 'penalty_amount_net' :
                let penalty_amount=this.props.t_MR_DETAIL.other_penalty_amount ? this.props.t_MR_DETAIL.other_penalty_amount: 0
                let calPenalty_amount =  this.chkNumber(penalty_amount)  + this.chkNumber(changeValue)
                dataState = {
                    ...dataState,
                    sum_penalty_cal : this.setFormateMomey(calPenalty_amount),
                }
            break
            case 'other_penalty_amount' :
                let other_penalty_amount =this.props.t_MR_DETAIL.penalty_amount ? this.props.t_MR_DETAIL.penalty_amount : 0 
                let calOther_penalty_amount = this.chkNumber(other_penalty_amount)  + this.chkNumber(changeValue)
                dataState = {
                    ...dataState,
                    sum_penalty_cal : this.setFormateMomey(calOther_penalty_amount),
                }
            break
            case 'retention_amount' : 
                dataState = {
                    ...dataState,
                    retention_cal : this.setFormateMomey(changeValue),
                }
            break
            case 'advance_payment_amount' : 
                dataState = {
                    ...dataState,
                    advance_payment_cal : this.setFormateMomey(changeValue),
                }
            break
        }
        
        dataState = {
            ...dataState,
            mr_amount : 
            this.setFormateMomey(
                this.chkNumber(dataState.ir_amount) +  this.chkNumber(t_MR_DETAIL.up_dept_amount) 
                - ( 
                    this.chkNumber(dataState.sum_penalty_cal) +
                    this.chkNumber(t_MR_DETAIL.down_dept_amount)+
                    this.chkNumber(dataState.retention_cal)+
                    this.chkNumber(dataState.advance_payment_cal)
                )
            )
        }

        this.setState(dataState)
    }
    handleChange(event){
        const numeral = require('numeral');
        const name = event.target.name;
        
        
        if(name === 'penalty_amount' || name === 'other_penalty_amount' || 
            name === 'retention_amount' || name === 'advance_payment_amount'){
                event.target.value = numeral(event.target.value).format(event.target.step);
                this.recalMRAmount(name,event.target.value)
        }

        this.props.handleChange(event);
    }

    handleInTimeChange(event) {
        this.handleChange(event);

        if (event.target.value === 'in_time') {
            this.clearInTimeCtr();
            this.clearPenaltyCtr();
            this.clearNoPenaltyCtr();

            
            this.props.handleChangeByName('', 'penalty_result');
            this.penalty_result_ref.current.checked = false;
            this.penalty_no_result_ref.current.checked = false;
        } else {
            this.clearPenaltyCtr();
            this.clearNoPenaltyCtr();

            this.props.handleChangeByName('penalty', 'penalty_result');
            this.penalty_result_ref.current.checked = true;
            this.penalty_no_result_ref.current.checked = false;
        }

    }

    handlePenaltyChange(event) {
        this.handleChange(event);
        if (event.target.value === 'penalty') {
            this.clearPenaltyCtr();
        } else {
            this.clearNoPenaltyCtr();
        }
    }

    handleOtherPenaltyChange(event) {
        this.handleChange(event);
        this.props.handleChangeByName('', 'other_penalty_amount');
        this.props.handleChangeByName('', 'other_penalty_remark');

        //this.other_penalty_amount_ref.current.value = ''
        this.other_penalty_remark_ref.current.value = ''
        this.recalMRAmount('other_penalty_amount',0)

    }

    handleRetentionChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','retention_amount');
        this.props.handleChangeByName('','retention_remark');

        //this.retention_amount_ref.current.value = ''
        this.retention_remark_ref.current.value = ''
        this.recalMRAmount('retention_amount',0)

    }

    handleAdvancePaymentChange(event){
        this.handleChange(event);
        this.props.handleChangeByName('','advance_payment_amount');
        this.props.handleChangeByName('','advance_payment_remark');
        
        //this.advance_payment_amount_ref.current.value = ''
        this.advance_payment_remark_ref.current.value = ''
        this.recalMRAmount('advance_payment_amount',0)

    }

    clearInTimeCtr() {
        this.props.handleChangeByName('', 'delay_day_no');
        this.props.handleChangeByName('', 'delay_remark');
        // this.delay_day_no_ref.current.value = ''
        this.delay_remark_ref.current.value = ''
    }

    clearPenaltyCtr() {
        this.props.handleChangeByName('', 'approval_of_penalty_exception_doc_no');
        this.props.handleChangeByName('', 'approval_of_penalty_exception_doc_date');
        this.approval_of_penalty_exception_doc_no_ref.current.value = ''
        //this.approval_of_penalty_exception_doc_date_ref.current.value = ''
    }

    clearNoPenaltyCtr() {
        this.props.handleChangeByName('', 'penalty_amount');
        this.props.handleChangeByName('', 'penalty_doc_no');
        this.props.handleChangeByName('', 'penalty_doc_date');
        //this.penalty_amount_ref.current.value = ''
        //this.penalty_doc_no_ref.current.value = ''
        //this.penalty_doc_date_ref.current.value = ''
        this.recalMRAmount('penalty_amount',0)
    }

    toBoolean(value){

            if(value === 1 )
                return true
            else if(value === true )
                return true
            else
                return false
    }
    

    componentWillReceiveProps(nextProps) {

        // console.log("PanelFine-componentWillReceiveProps()");
        if (this.state.transaction_no !== nextProps.t_MR_DETAIL.transaction_no) {
    
            if(nextProps.t_MR_DETAIL.transaction_no){
                    this.setState({
                        transaction_no: nextProps.t_MR_DETAIL.transaction_no
                    })
            }else{
                // console.log("nextProps.t_MR_DETAIL.transaction_no is null!")
            }

        }

    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.t_MR_DETAIL.mr_ref_no !== this.props.t_MR_DETAIL.mr_ref_no )   
        {
            const numeral = require('numeral');
            window.$('#other_penalty_amount').val(numeral(this.props.t_MR_DETAIL.other_penalty_amount).format('0,0.00'))
            window.$('#retention_amount').val(numeral(this.props.t_MR_DETAIL.retention_amount).format('0,0.00'))
            window.$('#advance_payment_amount').val(numeral(this.props.t_MR_DETAIL.advance_payment_amount).format('0,0.00'))
            window.$('#penalty_amount').val(numeral(this.props.t_MR_DETAIL.penalty_amount).format('0,0.00'))
            window.$('#delay_day_no').val(numeral(this.props.t_MR_DETAIL.delay_day_no).format('0,0.00'))
            this.recalIRAmount();
        }
    }

    
    componentDidMount() {

        $(function () {
            window.onComponentDidMount()
        })
    }

    renderPenaltyAmount() {
        const numeral = require('numeral');
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") {
            return <input
                name="penalty_amount"
                className="form-control form-control-190 mr-3"
                id="penalty_amount"
                disabled={true}
                //ref={this.penalty_amount_ref}
            />
        }
        else {
            return <InputDecimal
                name="penalty_amount"
                // pattern="[0-9.]*"
                //defaultValue={t_MR_DETAIL.penalty_result === "penalty" ? t_MR_DETAIL.penalty_amount : ''}
                className="form-control form-control-190 mr-3"
                id="penalty_amount"
                onBlur={this.handleChange}
                //ref={this.penalty_amount_ref}
                doctype="*"
                tagid="mr.penalty_amount"

                defaultValue={numeral(t_MR_DETAIL.penalty_amount).format('0,0.00')}
                inputMode="decimal"
                step="0,0.00"
                disabled={viewMode}
                viewMode={viewMode}
            />
        }

    }

    renderPenaltyDocNo() {
        let lableName = "แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือเลขที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") {
            return <React.Fragment>
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <label htmlFor="penalty_doc_no" className="rrs-label mr-3">
                        {lableName} 
                    </label>
                </div>
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <input
                        id="penalty_doc_no"
                        name="penalty_doc_no"
                        className="form-control form-control-190"
                        disabled={true}
                        maxLength="20"
                    //ref={this.penalty_doc_no_ref}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                <label
                    id="#lbl-mr.penalty_no"
                    htmlFor="penalty_doc_no"
                    className="rrs-label mr-3" >
                    {/* <span className="required">*</span> */}
                    {lableName}
                </label>
                </div>
                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                    <Input
                        name="penalty_doc_no"
                        value={t_MR_DETAIL.penalty_doc_no}
                        className="form-control form-control-190"
                        id="penalty_doc_no"
                        onChange={this.handleChange}
                        //ref={this.penalty_doc_no_ref}
                        doctype="*"
                        tagid="mr.penalty_no"
                        disabled={viewMode}
                        maxLength="20"
                        viewMode={viewMode}
                    />
                </div>
            </React.Fragment >
        }
    }

    renderPenaltyDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") {
            return <React.Fragment>
                <label htmlFor="penalty_doc_date" className="rrs-label rrs-label-95">
                    {lableName} 
                </label>
                <div className="rrs-formgroup">
                    <DatePicker
                        value={t_MR_DETAIL.penalty_doc_date != null ? t_MR_DETAIL.penalty_doc_date : ''}
                        //key={`penalty_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="penalty_doc_date"
                        id="penalty_doc_date" 
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_date"
                    htmlFor="penalty_doc_date" 
                    className="rrs-label rrs-label-95" >
                    
                    {/* <span className="required">*</span>  */}
                    { lableName }
                </label>
                <div className="rrs-formgroup">
                    <DatePicker
                        //key={`penalty_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="penalty_doc_date"
                        id="penalty_doc_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.penalty_doc_date
                            ? moment(t_MR_DETAIL.penalty_doc_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.penalty_date"
                        disabled={viewMode}
                        viewMode={viewMode}
                    />
                </div>
            </React.Fragment>
        }
    }

    renderExceptionDocDate() {
        let lableName = "ลงวันที่"
        let { t_MR_DETAIL,viewMode } = this.props;
        if (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result === "penalty") {
            return <React.Fragment>
                <label htmlFor="approval_of_penalty_exception_doc_date" className="rrs-label rrs-label-95">
                    {lableName}
                </label>
                <div className="rrs-formgroup">
                <DatePicker
                        value={t_MR_DETAIL.approval_of_penalty_exception_doc_date != null ? t_MR_DETAIL.approval_of_penalty_exception_doc_date : ''}
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="approval_of_penalty_exception_doc_date"
                        id="approval_of_penalty_exception_doc_date"
                        tagid="mr.penalty_no_exception_date"
                        disabled={true}
                    />
                </div>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <label 
                    id="#lbl-mr.penalty_no_exception_date"
                    htmlFor="approval_of_penalty_exception_doc_date" 
                    className="rrs-label rrs-label-95" >
                    <span className="required">*</span>
                    {lableName}
                </label>
                <div className="rrs-formgroup">

                    <DatePicker
                        //key={`approval_of_penalty_exception_doc_date${t_MR_DETAIL.transaction_no}`}
                        name="approval_of_penalty_exception_doc_date"
                        id="approval_of_penalty_exception_doc_date"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        value={t_MR_DETAIL.approval_of_penalty_exception_doc_date
                            ? moment(t_MR_DETAIL.approval_of_penalty_exception_doc_date).format('DD/MM/YYYY')
                            : ""}
                        autocomplete="off"
                        readOnly={true}
                        doctype="*"
                        tagid="mr.penalty_no_exception_date"
                        disabled={viewMode || t_MR_DETAIL.delivery_exception_flag == null}
                        viewMode={viewMode || t_MR_DETAIL.delivery_exception_flag == null}
                    />
                </div>
            </React.Fragment>
        }
    }

    render() {

        const numeral = require('numeral');
        let { t_MR_DETAIL,currency,viewMode } = this.props;
        
        return (

<>

{/*  
                    <div className="row mt-0 mb-2 pt-3">
                        <div className="col-lg-12">
                            <div className="sp-header-button-panel2 justify-content-start">
                            <UploadButton
                                    transaction_no={t_MR_DETAIL.transaction_no}
                                    modalId={'attachedDocumentPenaltyModal'}
                                    viewMode={viewMode}
                                    defaultFileName ={'เอกสารแนบ'}
                                    file_category={'P'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="sp-table-container">
                        <div className="row no-gutters sp-table-content">

                             <UploadList
                                key={"uploadlist-panelfine-" + utilityHelper.genDateKey()}
                                transaction_no={t_MR_DETAIL.transaction_no}
                                file_category={'P'}
                                viewMode={viewMode}
                            /> 

                        </div>
                    </div>  */}



                    {/* <div className="row rrs-fine-box">
                        <div className="col-2">
                            <label className={`radiocontainer ${viewMode?'':'clickable'}`}>ภายในเวลากำหนด
                                <input
                                    type="radio"
                                    name="delivery_exception_flag"
                                    id="delivery_exception_flag2"
                                    defaultValue="in_time"
                                    checked={t_MR_DETAIL.delivery_exception_flag === "in_time"}
                                    onChange={this.handleInTimeChange} 
                                    disabled={viewMode}
                                />
                                <span className="checkmark" />
                            </label>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">
                            <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`}>
                                    {
                                        t_MR_DETAIL.delivery_exception_flag == "delay_time" 
                                        && (<span className="required">*</span>)
                                    }ล่าช้ากว่าเวลากำหนด
                                    <input
                                        type="radio"
                                        name="delivery_exception_flag"
                                        id="delivery_exception_flag3"
                                        defaultValue="delay_time"
                                        checked={t_MR_DETAIL.delivery_exception_flag == "delay_time"}
                                        onChange={this.handleInTimeChange} 
                                        disabled={viewMode}
                                    />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">

                                {(t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null)
                                    && (
                                        <input
                                            name="delay_day_no"
                                            className="form-control form-control-small"
                                            id="delay_day_no"
                                            disabled={true}
                                        />
                                    )
                                }

                                {t_MR_DETAIL.delivery_exception_flag == "delay_time"
                                    && (
                                        <InputDecimal
                                            name="delay_day_no"
                                            className="form-control form-control-small"
                                            id="delay_day_no"
                                            onBlur={this.handleChange}
                                            disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || viewMode}
                                            defaultValue={numeral(t_MR_DETAIL.delay_day_no).format('0,0')}
                                            inputMode="decimal"
                                            step="0,0"
                                            floatingPoint={0}
                                            maxLength="6"
                                        />
                                    )
                                }

                                
                                <label htmlFor="cc" className="rrs-label rrs-label-95 ml-2 ">วัน</label>
                            </div>
                            <div className="col-auto d-flex">
                                <label htmlFor="cc" className="rrs-label rrs-label-95">
                                {
                                    t_MR_DETAIL.delivery_exception_flag == "delay_time" 
                                    && (<span className="required">*</span>)
                                }เนื่องจาก</label>  
                                <div className="rrs-detail-data">
                                    <textarea
                                        cols={80}
                                        key={`delay_remark${t_MR_DETAIL.transaction_no}`}
                                        name="delay_remark"
                                        id="delay_remark"
                                        className="form-control rrs-textarea"
                                        value={t_MR_DETAIL.delay_remark != null ? t_MR_DETAIL.delay_remark:''}
                                        onChange={this.handleChange} 
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag === null || viewMode}
                                        ref={this.delay_remark_ref}
                                        maxLength="3000"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`} id="#lbl-mr.penalty_amount">
                                    {
                                        (t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty") == false
                                        && (<span className="required">*</span>)
                                    }
                                    จำนวนเงินปรับ
                                    <input
                                        type="radio"
                                        name="penalty_result"
                                        defaultValue="penalty"
                                        checked={t_MR_DETAIL.penalty_result === "penalty"}
                                        onChange={this.handlePenaltyChange}
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode}
                                        ref={this.penalty_result_ref}
                                    />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">
                                {
                                    this.renderPenaltyAmount()
                                }
                            </div>
                            <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                <input
                                    key={`pa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="pa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto">&nbsp;</div>

                            {
                                this.renderPenaltyDocNo()
                            }

                            <div className="col-auto rrs-detail-data d-flex align-items-start flex-wrap">
                                {
                                    this.renderPenaltyDocDate()
                                }

                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">
                            
                            <div className="col-auto">
                                <label className={`radiocontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ยกเว้นค่าปรับ
                                <input
                                        type="radio"
                                        name="penalty_result"
                                        defaultValue="no_penalty"
                                        checked={t_MR_DETAIL.penalty_result === "no_penalty"}
                                        onChange={this.handlePenaltyChange} 
                                        disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null || viewMode}
                                        ref={this.penalty_no_result_ref}
                                        />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            
                            <div className="col-auto rrs-detail-data d-flex">

                                <label htmlFor="approval_of_penalty_exception_doc_no" className="rrs-label mr-3">                                
                                {
                                        t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.penalty_result !== "penalty"
                                        && (<span className="required">*</span>)
                                }ตามหนังสือยกเว้นค่าปรับเลขที่</label>
                                <input
                                    key={`approval_of_penalty_exception_doc_no${t_MR_DETAIL.transaction_no}`}
                                    name="approval_of_penalty_exception_doc_no"
                                    defaultValue={t_MR_DETAIL.approval_of_penalty_exception_doc_no}
                                    className="form-control form-control-190"
                                    id="approval_of_penalty_exception_doc_no"
                                    onBlur={this.handleChange}
                                    disabled={t_MR_DETAIL.delivery_exception_flag === "in_time" || t_MR_DETAIL.delivery_exception_flag == null  || t_MR_DETAIL.penalty_result === "penalty" || viewMode}
                                    ref={this.approval_of_penalty_exception_doc_no_ref}
                                    maxLength="40"
                                />
                            </div>
                            <div className="col-auto rrs-detail-data d-flex align-items-start">
                                {
                                    this.renderExceptionDocDate()
                                }
                                
                            </div>
                        </div>
                    </div>

                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>ค่าปรับอื่นๆ
                                    <input
                                        type="checkbox"
                                        name="other_penalty_flag"
                                        id="other_penalty_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.other_penalty_flag)}
                                        onChange={this.handleOtherPenaltyChange} 
                                        disabled={viewMode}
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">
                                <label htmlFor="other_penalty_amount" className="rrs-label rrs-label-95">จำนวนเงิน</label>
                                { this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false
                                    && (
                                    <input
                                        name="other_penalty_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="other_penalty_amount"
                                        inputMode="decimal"
                                        step="0,0.00"
                                        disabled={true}
                                    />
                                    )
                                }
                                {
                                    this.toBoolean(t_MR_DETAIL.other_penalty_flag) === true
                                    && (
                                        <InputDecimal
                                    name="other_penalty_amount"
                                    // pattern="[0-9.]*"
                                    // defaultValue={t_MR_DETAIL.other_penalty_amount}
                                    className="form-control form-control-190 mr-3"
                                    id="other_penalty_amount"
                                    onBlur={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                                    //ref={this.other_penalty_amount_ref}
                                    defaultValue={numeral(t_MR_DETAIL.other_penalty_amount).format('0,0.00')}
                                    //value={numeral(t_MR_DETAIL.other_penalty_amount).format('0,0.00')}
                                    inputMode="decimal"
                                    step="0,0.00"
                                    xValue={t_MR_DETAIL.other_penalty_amount}
                                />
                                    )
                                }
                                
                            </div>
                            <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                <input
                                    key={`opa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="opa_currency"
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 col-xl-4 rrs-detail-data d-flex">
                                <label htmlFor="other_penalty_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                                <input
                                    key={`other_penalty_remark${t_MR_DETAIL.transaction_no}`}
                                    name="other_penalty_remark"
                                    value={t_MR_DETAIL.other_penalty_remark}
                                    className="form-control"
                                    id="other_penalty_remark"
                                    onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.other_penalty_flag) === false || viewMode}
                                    ref={this.other_penalty_remark_ref}
                                    maxLength="500"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>Retention
                                    <input
                                        type="checkbox"
                                        name="retention_flag"
                                        id="retention_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.retention_flag)}
                                        onChange={this.handleRetentionChange} 
                                        disabled={viewMode}    
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">
                                <label htmlFor="retention_amount" className="rrs-label rrs-label-95">จำนวนเงิน</label>
                                { this.toBoolean(t_MR_DETAIL.retention_flag) === false
                                    && (
                                    <input
                                        name="retention_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="retention_amount"
                                        disabled={true}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.retention_flag) === true
                                    && (
                                        <InputDecimal
                                        name="retention_amount"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.retention_amount}
                                        className="form-control form-control-190 mr-3"
                                        id="retention_amount"
                                        onBlur={this.handleChange}
                                        disabled={this.toBoolean(t_MR_DETAIL.retention_flag) === false || viewMode}
                                        //ref={this.retention_amount_ref}
                                        defaultValue={numeral(t_MR_DETAIL.retention_amount).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
    
                                    />
                                    )
                                }
                                
                            </div>
                            <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                <input
                                    key={`ra_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="ra_currency"
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 col-xl-4 rrs-detail-data d-flex">
                                <label htmlFor="retention_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                                <input
                                    key={`retention_remark${t_MR_DETAIL.transaction_no}`}
                                    name="retention_remark"
                                    value={t_MR_DETAIL.retention_remark}
                                    className="form-control"
                                    id="retention_remark"
                                    onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.retention_flag) === false || viewMode }
                                    ref={this.retention_remark_ref}
                                    maxLength="500"

                                />
                            </div>
                        </div>
                    </div>
                    <div className="row rrs-fine-box">
                        <div className="col-12 d-md-flex align-items-start flex-wrap px-0 rrs-fine-box-bb">
                            <div className="col-auto col-rrs-checkbox">
                                <label className={`checkboxcontainer rrs-fine-label ${viewMode?'':'clickable'}`}>Advance Payment
                                    <input
                                        type="checkbox"
                                        name="advance_payment_flag"
                                        id="advance_payment_flag"
                                        checked={this.toBoolean(t_MR_DETAIL.advance_payment_flag)}
                                        onChange={this.handleAdvancePaymentChange} 
                                        disabled={viewMode}        
                                    />
                                    <span className="checkboxmark" />
                                </label>
                            </div>
                            <div className="col-auto rrs-detail-data d-flex">
                                <label htmlFor="advance_payment_amount" className="rrs-label rrs-label-95">จำนวนเงิน</label>
                                { this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false
                                    && (
                                    <input
                                        name="advance_payment_amount"
                                        className="form-control form-control-190 mr-3"
                                        id="advance_payment_amount"
                                        disabled={true}
                                        inputMode="decimal"
                                        step="0,0.00"
                                    />
                                    )
                                }
                                { this.toBoolean(t_MR_DETAIL.advance_payment_flag) === true
                                    && (
                                        <InputDecimal
                                        name="advance_payment_amount"
                                        // pattern="[0-9.]*"
                                        // defaultValue={t_MR_DETAIL.advance_payment_amount}
                                        className="form-control form-control-190 mr-3"
                                        id="advance_payment_amount"
                                        onBlur={this.handleChange} 
                                        disabled={this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false || viewMode}
                                        //ref={this.advance_payment_amount_ref}
                                        defaultValue={numeral(t_MR_DETAIL.advance_payment_amount).format('0,0.00')}
                                        inputMode="decimal"
                                        step="0,0.00"
    
                                        />
                                    )
                                }
                                
                            </div>
                            <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                <input
                                    key={`apa_currency${t_MR_DETAIL.transaction_no}`}
                                    name="currency"
                                    defaultValue={currency}
                                    className="form-control form-control-small"
                                    id="apa_currency"
                                    onBlur={this.handleChange}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 col-xl-4 rrs-detail-data d-flex">
                                <label htmlFor="advance_payment_remark" className="rrs-label rrs-label-95">เนื่องจาก</label>
                                <input
                                    key={`advance_payment_remark${t_MR_DETAIL.transaction_no}`}
                                    name="advance_payment_remark"
                                    value={t_MR_DETAIL.advance_payment_remark}
                                    className="form-control"
                                    id="advance_payment_remark"
                                    onChange={this.handleChange}
                                    disabled={this.toBoolean(t_MR_DETAIL.advance_payment_flag) === false || viewMode}
                                    ref={this.advance_payment_remark_ref}
                                    maxLength="500"
                                />
                            </div>
                        </div>
                    </div>
                     */}
                   
                   <PanelFineMom
                                handleChange={this.handleChange}
                                handleChangeByName={this.props.handleChangeByName}
                                upload_files={this.props.upload_files}
                                t_MR_DETAIL={t_MR_DETAIL}
                                t_HEADER={this.props.t_HEADER}
                                currency={this.props.t_PO_DETAIL.currency}
                                viewMode={true}
                                id={2}
                            />   

                            
                            <div className="rrs-detail3">
                            <div className="rrs-detail-data">
                    <div className="d-flex align-items-center flex-column">
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:20}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                                <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="ir_amount" className="rrs-label rrs-label-180">จำนวนเงินตามใบแจ้งหนี้</label>
                                    <input
                                            value={this.state.ir_amount}
                                            id="ir_amount"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="sum_penalty_cal" className="rrs-label rrs-label-180">จำนวนเงินค่าปรับรวม</label>
                                    <input
                                            value={this.state.sum_penalty_cal}
                                            id="sum_penalty_cal"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                            <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="retention_cal" className="rrs-label rrs-label-180">หักเงิน Retention </label>
                                    <input
                                            value={this.state.retention_cal}
                                            id="retention_cal"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                                <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="advance_payment_cal" className="rrs-label rrs-label-180">Advance payment </label>
                                    <input
                                            value={this.state.advance_payment_cal}
                                            id="advance_payment_cal"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                                <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="advance_payment_cal" className="rrs-label rrs-label-180">จำนวนเงินลดหนี้ </label>
                                    <input
                                            value={numeral(t_MR_DETAIL.down_dept_amount).format('0,0.00')}
                                            id="advance_payment_cal"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                                <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="advance_payment_cal" className="rrs-label rrs-label-180">จำนวนเงินเพิ่มหนี้ </label>
                                    <input
                                            value={numeral(t_MR_DETAIL.up_dept_amount).format('0,0.00')}
                                            id="advance_payment_cal"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row rrs-fine-box mr-amount" style={{paddingTop:5}}>
                            <div className="col-12 d-md-flex align-items-start flex-wrap px-0">
                                <div className="col-auto rrs-detail-data d-flex">
                                    <label htmlFor="mr_amount" className="rrs-label rrs-label-180">จำนวนเงินคงเหลือ<br></br> (ไม่รวม VAT)</label>
                                    <input
                                            value={this.state.mr_amount}
                                            id="mr_amount"
                                            className="form-control form-control-190 mr-3"
                                            disabled={true}
                                    />
                                </div>
                                <div className="col-auto rrs-detail-data d-flex flex-wrap">
                                    <label htmlFor="ddd" className="rrs-label rrs-label-95">สกุลเงิน</label>
                                    <input
                                        key={`cal_currency1${t_MR_DETAIL.transaction_no}`}
                                        name="currency"
                                        defaultValue={currency}
                                        className="form-control form-control-small"
                                        id="cal_currency1"
                                        onBlur={this.handleChange}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_IR_ITEM: MainRedux.t_IR_ITEM,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
        t_HEADER : MainRedux.t_HEADER,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL
    }
}

export default connect(
    mapStateToProps,
    null
)(PanelFine)